import LogoutHandler from 'client/util/LogoutHandler';

export default [
  {
    path: '/logout',
    name: 'Logout',
    beforeEnter: () => {
      LogoutHandler.handleLogout();
    },
  },
];
